import SectionHeader from "../SectionHeader";
// import PageIcons from "../PageIcons";
import "./style.scss";
export default function HeaderSection({
  children,
  back,
  dangerouslySetInnerHTML = false,
}) {

  return (
    <header className="header-section-component">
      <div className="top">
        {dangerouslySetInnerHTML ? (
          <SectionHeader
            back={back}
            dangerouslySetInnerHTML={dangerouslySetInnerHTML}
            pageHeader
          />
        ) : (
          <SectionHeader back={back} pageHeader>
            {children}
          </SectionHeader>
        )}
        {/* <PageIcons /> */}
      </div>
    </header>
  );
}
